import { render, staticRenderFns } from "./productosRelacionados.vue?vue&type=template&id=e22d01ba&"
import script from "./productosRelacionados.vue?vue&type=script&lang=js&"
export * from "./productosRelacionados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports